import { BOOLEAN_RADIO_INPUT_OPTIONS } from "@constants/boolean-radio-input-options"
import { resources } from "@constants/hardcoded-strings"
import { REDIRECT_TO_CALLBACK_URL_ON_ERROR_PROPERTY_TYPE_ID } from "@constants/verification-service-details-constants"
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body"
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header"
import { PropertiesSectionDescription } from "@containers/common/properties-sections/properties-section-header/properties-section-description"
import { RadioInputFormGroup } from "@containers/common/radio-input-form-group/radio-input-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { AxnDocumentationLink } from "@idw-types/data/reference-data/axn"
import { FormattedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";
import { getPropertyValuesPassedToService } from "@utils/applied-profile-util";
import { useMemo } from "react";

type WorkflowRedirectToCallBackUrlOnErrorContainerProps = {
    isDisabled: boolean;
    documentationLinks: Array<AxnDocumentationLink>;
    workflowDetailsConfigurationState: FormattedWorkflowDetailsConfiguration;
    updateProperties: (properties: Array<{ propertyTypeId: string, newValue: string, added: boolean }>) => void;
}

export const WorkflowRedirectToCallBackUrlOnErrorContainer = (props: WorkflowRedirectToCallBackUrlOnErrorContainerProps) => {
    const {
        isDisabled,
        documentationLinks,
        workflowDetailsConfigurationState,
        updateProperties
    } = props;

    const isRedirectToCallbackUrlOnErrorEnabled = useMemo(() => {
        const propertyValue = getPropertyValuesPassedToService(
            workflowDetailsConfigurationState.appliedProfiles,
            REDIRECT_TO_CALLBACK_URL_ON_ERROR_PROPERTY_TYPE_ID
        );
        return isStringTrue(propertyValue);
    }, [workflowDetailsConfigurationState.appliedProfiles]);


    const handleRedirectToCallbackUrlOnErrorChanged = (newValue: string) => {
        if (isStringTrue(newValue)) {
            updateProperties([{ propertyTypeId: REDIRECT_TO_CALLBACK_URL_ON_ERROR_PROPERTY_TYPE_ID, newValue: "true", added: true }]);
        } else {
            updateProperties([{ propertyTypeId: REDIRECT_TO_CALLBACK_URL_ON_ERROR_PROPERTY_TYPE_ID, newValue: null, added: false }]);
        }
    };

    const documentationLink = useMemo(() => {
        if (documentationLinks.length) {
            const documentationLink = documentationLinks.find(doc => doc.shortName === 'redirect-on-error-widget');
            if (documentationLink) {
                return documentationLink.url;
            }
        }

        return '';
    }, [documentationLinks]);

    const resource = resources.pages.verificationServiceDetails.tabs.general.subTabs.advanced.sections.workflowRedirectToCallbackUrlOnError;
    
    return (
        <div>
            <ContentPageHeader title={resource.title} />
            <ContentPageBody isMaxWidth={true}>
                <PropertiesSectionDescription description={resource.description} documentationLink={documentationLink} />
                <div>
                    <RadioInputFormGroup
                        controlId={'redirect-to-callback-url-on-error-toggle'}
                        automationId={'redirect-to-callback-url-on-error-toggle'}
                        disabled={isDisabled || !workflowDetailsConfigurationState.permissions.canModifyNonRestrictedProperties}
                        isRequired={false}
                        label={resource.inputs.redirectOnError.label}
                        layout={LayoutTypes.ROW}
                        labelWidth={LabelWidthTypes.MEDIUM}
                        value={isRedirectToCallbackUrlOnErrorEnabled
                            ? BOOLEAN_RADIO_INPUT_OPTIONS[0].value
                            : BOOLEAN_RADIO_INPUT_OPTIONS[1].value
                        }
                        options={BOOLEAN_RADIO_INPUT_OPTIONS}
                        onChange={handleRedirectToCallbackUrlOnErrorChanged}
                        afterLabelTooltipText={resource.inputs.redirectOnError.tooltip}
                    />
                </div>
            </ContentPageBody>

        </div>);

}